import {FC} from 'react';

import NavLink from '~/common/NavLink/NavLink';
import {Icons, SidebarIcons} from '~/common/Icon';
import CardBordered from '~/common/display/CardBordered/CardBordered';

import s from '../styles.module.scss';
import {LinksGroupProps} from './types';

const FinancesLinks: FC<LinksGroupProps> = ({onClickBack}) => {
  return (
    <CardBordered className={s.card}>
      <NavLink icon={Icons.dollarBox} label="Finance" carretLeft onClick={onClickBack} />
      <NavLink
        href="/profile/transactions"
        icon={SidebarIcons.transactions}
        label="My Transactions"
        asChild
      />
      <NavLink icon={SidebarIcons.funds} label="Add Funds" href="/profile/credit" asChild />
      <NavLink
        href="/profile/add-invoice"
        icon={SidebarIcons.invoiceGenerate}
        label="Generate Invoice"
        asChild
      />
      <NavLink
        href="/profile/unpaid-invoices"
        icon={SidebarIcons.invoicePay}
        label="Pay Invoice"
        asChild
      />
      <NavLink
        href="/profile/paid-invoices"
        icon={SidebarIcons.invoicePaid}
        label="Paid Invoices"
        asChild
      />
    </CardBordered>
  );
};

export default FinancesLinks;
